/**
 * Removes all paragraphs with empty text values from the 'raw' JSON string property of a data object.
 * The function parses the JSON, filters out paragraphs where all contained text nodes are empty or contain only whitespace,
 * and returns a new data object with the modified JSON string, maintaining the original data structure without empty paragraphs.
 *
 * @param {Object} data - The data object containing a 'raw' property with a JSON string that needs filtering.
 * @returns {Object} - A new data object with the 'raw' property updated to exclude empty paragraphs.
 */

function removeEmptyParagraphs(data) {
  try {
    if (!data?.raw) {
      return data
    }

    const parsedData = JSON.parse(data?.raw)

    const isEmptyParagraph = (paragraph) =>
      paragraph.content.every((subItem) => subItem?.value?.trim() === '')

    const filterContent = (contents) =>
      contents
        .map((item) => {
          if (item.nodeType === 'paragraph') {
            if (isEmptyParagraph(item)) {
              return null // Return null for empty paragraphs to filter them out later
            }
            return item
          }

          if (item.content) {
            return {
              ...item,
              content: filterContent(item.content),
            }
          }

          return item
        })
        .filter((item) => item !== null) // Filter out the empty paragraphs

    if (Array.isArray(parsedData.content)) {
      parsedData.content = filterContent(parsedData.content)
    }

    return {
      ...data,
      raw: JSON.stringify(parsedData),
    }
  } catch (error) {
    console.error('Failed to parse data:', error) // eslint-disable-line no-console
    return data
  }
}

export default removeEmptyParagraphs
